import React from 'react';

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'default',
  disabled = false,
  loading = false,
  icon: Icon,
  iconPosition = 'left',
  className = '',
  ...props 
}) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 ease-out disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-gradient-to-r from-primary to-accent text-white hover:shadow-glow hover:scale-[1.02] active:scale-[0.98]',
    secondary: 'bg-white text-text-primary border border-border hover:border-primary/30 hover:bg-primary/5',
    ghost: 'text-text-secondary hover:bg-gray-100 hover:text-text-primary',
    danger: 'bg-red-500 text-white hover:bg-red-600',
    success: 'bg-success text-white hover:bg-green-600'
  };

  const sizes = {
    small: 'px-3 py-1.5 text-sm rounded-lg gap-1.5',
    default: 'px-5 py-2.5 text-sm rounded-xl gap-2',
    large: 'px-6 py-3 text-base rounded-xl gap-2'
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle 
            className="opacity-25" 
            cx="12" cy="12" r="10" 
            stroke="currentColor" 
            strokeWidth="4"
            fill="none"
          />
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      ) : (
        <>
          {Icon && iconPosition === 'left' && <Icon className="w-4 h-4" />}
          {children}
          {Icon && iconPosition === 'right' && <Icon className="w-4 h-4" />}
        </>
      )}
    </button>
  );
}
